// Stripe Payment Link URLs per tier + billing cadence.
// Monthly links are required. Annual links are optional — when absent the
// pricing-page toggle falls back to the monthly link with a note. To wire
// annual billing in Stripe: Dashboard → Payment Links → New payment link →
// pick a yearly-recurring price → add the resulting URL to Vercel env as
// VITE_STRIPE_STARTER_ANNUAL / _GROWTH_ANNUAL / _SCALE_ANNUAL.

export const STRIPE_LINKS = {
  monthly: {
    starter: import.meta.env.VITE_STRIPE_STARTER,
    growth:  import.meta.env.VITE_STRIPE_GROWTH,
    scale:   import.meta.env.VITE_STRIPE_SCALE,
  },
  annual: {
    starter: import.meta.env.VITE_STRIPE_STARTER_ANNUAL,
    growth:  import.meta.env.VITE_STRIPE_GROWTH_ANNUAL,
    scale:   import.meta.env.VITE_STRIPE_SCALE_ANNUAL,
  },
  // 15-day paid trial. Single Stripe subscription configured to charge
  // $97 on day 0, then $347 every month after that. See
  // docs/stripe-trial-setup.md for Dashboard configuration.
  trial: import.meta.env.VITE_STRIPE_TRIAL,

  // Legacy flat shape kept so existing imports (client portal, etc.) don't
  // break. Points at the monthly tier links.
  starter: import.meta.env.VITE_STRIPE_STARTER,
  growth:  import.meta.env.VITE_STRIPE_GROWTH,
  scale:   import.meta.env.VITE_STRIPE_SCALE,
};

// Reject anything that isn't a real Stripe payment link (defense against
// `javascript:` URLs or arbitrary redirects landing in client.stripeLink).
const STRIPE_HOST_PREFIX = "https://buy.stripe.com/";
export const isValidStripeUrl = (url) =>
  typeof url === "string" && url.startsWith(STRIPE_HOST_PREFIX);

// Returns the input if it looks like a Stripe link, otherwise the safe fallback.
export const safeStripeUrl = (url, fallback = STRIPE_LINKS.growth) =>
  isValidStripeUrl(url) ? url : fallback;

// Picks the right link for (tier, cycle), with safe fallback chain:
// annual → monthly → growth-monthly (the universal fallback).
export const linkFor = (tier, cycle = "monthly") => {
  const want = STRIPE_LINKS[cycle]?.[tier];
  if (isValidStripeUrl(want)) return want;
  const mo = STRIPE_LINKS.monthly?.[tier];
  if (isValidStripeUrl(mo)) return mo;
  return STRIPE_LINKS.growth;
};

// True when the project has an annual payment link configured for this
// tier. Lets the pricing page enable/disable the toggle gracefully.
export const hasAnnualLink = (tier) =>
  isValidStripeUrl(STRIPE_LINKS.annual?.[tier]);
